const axios = require('axios');
const iconv = require('iconv-lite');
const customStorage = require('@/plugins/customStorage').default;

export default class printQueue {
  static async print(pData) {
    const env = customStorage().get.item('easy.account.x-api-env');
    const data = pData;
    data.env = env;
    data.info = await this.encode(data.info);

    await axios.post(`${process.env.VUE_APP_SLS_API}/printers/qprint`, data);
  }

  static async encode(pValue) {
    const value = JSON.stringify(pValue);
    return iconv.encode(value.concat(''), 'ascii');
  }
}
